import React from 'react';

import {
  ConnectIframe,
  ConnectIframeProps,
} from '../../internal/iframe/connectIframe';
import Connect from '../../main/connect';

export default Connect(({ ...props }: ConnectIframeProps) => (
  <ConnectIframe
    {...props}
    width="100%"
    options={{ autoresize: true }}
    moduleType="fileViews"
  />
));
